import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { usePermissions } from "../context/PermissionsContext";

const ProtectedRoute = ({ children, menuName }) => {
  const { isAuthenticated } = useAuth();
  const { permissions, isLoading } = usePermissions();
  const location = useLocation();

  // Sidebar protected routes (only these need permission)
  const protectedMenuRoutes = [
    "देशी पर्चा",
    "अंग्रेजी पर्चा",
    "पिछला देशी पर्चा",
    "पिछला अंग्रेजी पर्चा",
    "देशी आमद",
    "अंग्रेजी आमद",
    "बॉक्स अंग्रेजी आमद",
    "बॉक्स देशी आमद",
    "देशी भेजान",
    "अंग्रेजी भेजान",
    "बॉक्स देशी भेजान",
    "बॉक्स अंग्रेजी भेजान",
    "खर्चा एंट्री",
    "पिछला खर्चा एंट्री",
    "देसी कमीशन",
    "अंग्रेज़ी कमीशन",
    "स्टाफ वेतन",
    "नामे / जमा",
    "दर अंतर",
    "फोनपे जमा",
    "बिकी रिपोर्ट",
    "पर्चा रिपोर्ट",
    "खर्च रिपोर्ट",
    "प्रिंट पर्चा"
  ];

  // Allow unauthenticated users only to Signin page
  if (!isAuthenticated && location.pathname !== "/signin") {
    return <Navigate to="/signin" replace />;
  }

  // If user is authenticated and it's not a protected menu route → allow
  if (!menuName || !protectedMenuRoutes.includes(menuName.trim())) {
    return children;
  }

  // Optional loading state
  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Check permission only for sidebar menu routes
  if (!permissions.includes(menuName.trim())) {
    return <Navigate to="/home" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
